import { forwardRef } from 'react';

import { ZyProofIcon } from '@/components/tiptap-editor/tiptap-icons/zyproof-icon';

import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

const ZyProofButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => {
    return (
        <GenericExtensionButton
            extensionName="zyProof"
            extensionType="extension"
            icon={ZyProofIcon}
            label="Insert Proof"
            command={editor => editor.commands.insertZyProof()}
            ref={ref}
            {...props}
        />
    );
});

ZyProofButton.displayName = 'ZyProofButton';

export default ZyProofButton;
